export default "__VITE_ASSET__CqSd5Ook__";